import React from 'react';
import PropTypes from 'prop-types';

import AuthAnalyticsInterceptor from './AuthAnalyticsInterceptor';
import AnalyticsContext from './AnalyticsContext';
import withAnalytics from './withAnalytics';
import withPageViewTracking from './withPageViewTracking';
import trackEventOnMount from './trackEventOnMount';
import mixpanelAnalytics from './MixpanelAnalytics';

const AnalyticsProvider = ({ children }) => (
  <AnalyticsContext.Provider value={{ analytics: mixpanelAnalytics }}>
    {children}
  </AnalyticsContext.Provider>
);

AnalyticsContext.Provider.propTypes = {
  analytics: PropTypes.object
};

AnalyticsProvider.propTypes = {
  children: PropTypes.node,
  analytics: PropTypes.object
};

export {
  AnalyticsProvider,
  withAnalytics,
  trackEventOnMount,
  withPageViewTracking,
  AuthAnalyticsInterceptor
};
